module.exports = __webpack_public_path__ + "static_portal/img/6.ba540073.jpg";